import {Component, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ContactBase} from '@backend';
import {ProjectBaseAbstract} from '@project/project-base/project-base.abstract';
import {ProjectBaseComponent} from '@project/project-base/project-base.component';
import {SectionHeaderActions} from '@shared/components/section-header-actions/section-header-actions';

@Component({
  standalone: true,
  selector: 'app-public-project',
  imports: [ProjectBaseComponent],
  templateUrl: './public-project.component.html',
})
export class PublicProjectComponent extends ProjectBaseAbstract implements SectionHeaderActions {
  constructor(route: ActivatedRoute) {
    super();
    route.data.subscribe(d => {
      const {project, datasetTiles, resourceTiles} = d['projectData'];

      this.project.set(project);
      this.datasetTiles = datasetTiles;
      this.resourceTiles = resourceTiles;

      this.setProjectData(project, datasetTiles, resourceTiles);
    });
  }

  public sectionHeaderActions = signal([
    {
      target: '/help/public-data-commons/view-public-project',
      targetTab: '_blank',
      caption: 'Help',
      color: 'var(--mat-sys-primary)',
      icon: 'help_outline',
    },
  ]);

  protected buildMetadataTable() {
    const contact = this.project().contacts as ContactBase | undefined;
    const hasContact = !!(contact?.name || contact?.email || contact?.phone_number);

    this.metaTableData = [
      {
        key: 'keywords',
        display_name: 'Keywords',
        value: this.project().keywords.join(', '),
      },
      ...(hasContact
        ? [
            {
              key: 'contact',
              display_name: 'Contact',
              value: [contact.name ?? '', contact.email ?? '', contact.phone_number ?? ''],
            },
          ]
        : []),
      {
        key: 'storage_organization',
        display_name: 'Storage Organization',
        value: this.project().storage_organization.full_name,
      },
      {
        key: 'partners',
        display_name: 'Partner Institution(s)',
        value: this.project().partners.join(', '),
      },
      {
        key: 'funders',
        display_name: 'Funding Source(s)',
        value: this.project().funders.join(', '),
      },
      {
        key: 'website',
        display_name: 'Website',
        value: (this.project().web_page_urls ?? []).join(', '),
        link: this.project().web_page_urls?.length === 1 ? this.project().web_page_urls[0] : undefined,
      },
    ];
  }
}
